import {
  ACTUAL_ROUTER_URL,
  ActualLayout,
  ActualMainPage,
  AnnualFinancialReport,
  AnnualResourcingReport,
  App,
  AppLayout,
  AuthRoute,
  DailyReport,
  FinancialLayout,
  Home,
  IntervalReport,
  ManageSettings,
  ManageUsers,
  MultiSkill,
  MyOrganization,
  NotFound,
  OrgConfigViewAuthRoute,
  OrgConfigWizard,
  PeriodFinancialReport,
  PeriodResourcingReport,
  REPORT_ROUTER_URL,
  ROUTER_URL,
  ReportLayout,
  ResourcingLayout,
  Role,
  TrainingRecruitment,
  Wizard,
} from 'common-ui';
import { Navigate, createBrowserRouter } from 'react-router-dom';
import { HubspotSign } from '../components/hubspot';
import { LoginPage } from '../components/login';

export function createAppRouter() {
  return createBrowserRouter([
    {
      path: ROUTER_URL.Login,
      element: <LoginPage />,
    },
    {
      // Keep HubSpot signup/sign-in flow on /hubspot (do not redirect to /login).
      path: ROUTER_URL.Hubspot,
      element: <HubspotSign />,
    },
    {
      path: ROUTER_URL.Home,
      errorElement: <NotFound />,
      Component: App,
      children: [
        {
          element: <AppLayout />,
          children: [
            {
              index: true,
              element: <Home />,
            },
            {
              path: ROUTER_URL.Wizard,
              element: <Wizard />,
            },
            {
              element: <AuthRoute roles={[Role.Superadmin, Role.Admin]} />,
              children: [
                {
                  path: ROUTER_URL.Users,
                  element: <ManageUsers />,
                },
              ],
            },
            {
              element: <OrgConfigViewAuthRoute />,
              children: [
                {
                  path: ROUTER_URL.Organization,
                  element: <MyOrganization />,
                },
                {
                  path: ROUTER_URL.OrganizationWizard,
                  element: <OrgConfigWizard />,
                },
              ],
            },
            {
              path: ROUTER_URL.Report,
              element: <ReportLayout />,
              children: [
                {
                  index: true,
                  element: <Navigate to={REPORT_ROUTER_URL.Resourcing} replace />,
                },
                {
                  path: REPORT_ROUTER_URL.Resourcing,
                  element: <ResourcingLayout />,
                  children: [
                    {
                      index: true,
                      element: <Navigate to={REPORT_ROUTER_URL.Annual} replace />,
                    },
                    {
                      path: REPORT_ROUTER_URL.Annual,
                      element: <AnnualResourcingReport />,
                    },
                    {
                      path: REPORT_ROUTER_URL.Period,
                      element: <PeriodResourcingReport />,
                    },
                    {
                      path: REPORT_ROUTER_URL.Daily,
                      element: <DailyReport />,
                    },
                    {
                      path: REPORT_ROUTER_URL.Interval,
                      element: <IntervalReport />,
                    },
                  ],
                },
                {
                  path: REPORT_ROUTER_URL.Financial,
                  element: <FinancialLayout />,
                  children: [
                    {
                      index: true,
                      element: <Navigate to={REPORT_ROUTER_URL.Annual} replace />,
                    },
                    {
                      path: REPORT_ROUTER_URL.Annual,
                      element: <AnnualFinancialReport />,
                    },
                    {
                      path: REPORT_ROUTER_URL.Period,
                      element: <PeriodFinancialReport />,
                    },
                  ],
                },
                {
                  path: REPORT_ROUTER_URL.Training,
                  element: <TrainingRecruitment />,
                },
                {
                  path: REPORT_ROUTER_URL.Actual,
                  element: <ActualLayout />,
                  children: [
                    {
                      index: true,
                      element: <ActualMainPage />,
                    },
                    {
                      path: ACTUAL_ROUTER_URL.Settings,
                      element: <ManageSettings />,
                    },
                  ],
                },
              ],
            },
            {
              path: ROUTER_URL.MultiSkill,
              element: <MultiSkill />,
            },
          ],
        },
      ],
    },
  ]);
}
